// Updated version of 'autosuggest-highlight/match'
// Main Source: https://github.com/moroshko/autosuggest-highlight/blob/dabbeac222b22c6900e639054965c1c2946dc012/src/match.js
// Removed the diacritic dependency and converted to TypeScript

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_special_characters
const specialCharsRegex = /[.*+?^${}()|[\]\\]/g

// http://www.ecma-international.org/ecma-262/5.1/#sec-15.10.2.6
const wordCharacterRegex = /[a-z0-9_]/i

const whitespacesRegex = /\s+/

const escapeRegexCharacters = (str: string) => {
  return str.replace(specialCharsRegex, '\\$&')
}

const extend = (
  subject: { [x: string]: any },
  baseObject: {
    [x: string]: boolean
    insideWords: boolean
    findAllOccurrences: boolean
    requireMatchAll: boolean
  }
) => {
  subject = subject || {}
  Object.keys(subject).forEach(key => {
    baseObject[key] = !!subject[key]
  })
  return baseObject
}

export const match = (
  text: string,
  query: string,
  options?: { insideWords?: boolean; requireMatchAll?: boolean; findAllOccurrences?: boolean }
) => {
  options = extend(options || {}, {
    insideWords: false,
    findAllOccurrences: false,
    requireMatchAll: false,
  })

  return (
    query
      .trim()
      .split(whitespacesRegex)
      // If query is blank, we'll get empty string here, so let's filter it out.
      .filter((word: string) => {
        return word.length > 0
      })
      .reduce((result: [number, number][], word: string) => {
        const wordLen = word.length
        const prefix = !options?.insideWords && wordCharacterRegex.test(word[0]) ? '\\b' : ''
        const regex = new RegExp(prefix + escapeRegexCharacters(word), 'i')
        let occurrence

        occurrence = regex.exec(text)
        if (options?.requireMatchAll && occurrence === null) {
          text = ''
          return []
        }

        while (occurrence) {
          const { index } = occurrence
          result.push([index, index + wordLen])

          // Replace what we just found with spaces so we don't find it again.
          text =
            text.slice(0, index) + new Array(wordLen + 1).join(' ') + text.slice(index + wordLen)

          if (!options?.findAllOccurrences) {
            break
          }

          occurrence = regex.exec(text)
        }

        return result
      }, [])
      .sort((match1: number[], match2: number[]) => {
        return match1[0] - match2[0]
      })
  )
}
